function s(s,a){if(s.classList)return!!a&&s.classList.contains(a);return(" "+(s.className.baseVal||s.className)+" ").indexOf(" "+a+" ")!==-1}export{s as default};
//# sourceMappingURL=hasClass.js.map
